/**
 * 路由跳转
 * @param routeParams
 */
export const linkToRoute = function (routeParams: any) {
  return function () {
    this.$router.push(routeParams);
  };
};

// 是否有匹配路由
export function hasMatchRoute(router: any, routes = [], path = "") {
  return !!routes.find(o => {
    let route = router.matcher.match(path)?.matched?.[0];
    return route?.path === o.path;
  });
}
